module.exports = __webpack_public_path__ + "img/6.f66394a8.png";